export default "__VITE_ASSET__UXxhf514__"